import _ from 'lodash';
import { CalculatePercentage } from './percentage';

export function CheckRequireApproval(line, isFeedBackLoopEnabled) {
  if (!isFeedBackLoopEnabled) {
    return false;
  }
  if (_.has(line, 'feedbackStatus')) {
    if (line.feedbackStatus === 'Approved' || line.feedbackStatus.trim() === '') {
      return false;
    } else if (line.vendorConfirmQty === 0) {
      return false;
    } else {
      const isOverReceiptQuantity =
        Number(line.whseConfirmQty) + Number(line.qtyReceived) > Number(line.vendorConfirmQty);

      if (isOverReceiptQuantity) {
        const totalWarehouseQuantity = Number(line.whseConfirmQty) + Number(line.qtyReceived);
        const totalCost = Number((line.directUnitCost * Number(line.whseConfirmQty)).toFixed(2));

        const overReceiptPercentage = CalculatePercentage(
          line.vendorConfirmQty,
          totalWarehouseQuantity
        );
        if (overReceiptPercentage > 5 || totalCost >= 15000) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
